/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import TceTemplateDiagnostic from './TceTemplateDiagnostic';
const meta = {
    title: 'Features/Settings/Integrations/TceTemplateDiagnostic',
    component: TceTemplateDiagnostic,
    parameters: {
        layout: 'padded'
    },
    decorators: [
        (Story) => (React.createElement("div", { style: { maxWidth: '960px', margin: '40px auto' } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const Default = {};
